@use './variables' as *;
@use '../../styles/abstracts' as *;

.cob-card {
  display: $business-class-card-display;
  flex-direction: $business-class-card-flex-direction;
  justify-content: $business-class-card-justify-content;
  align-items: $business-class-card-align-items;
  box-sizing: $business-class-card-box-sizing;
  margin-bottom: $business-class-card-margin-bottom;
  padding: $business-class-card-padding;
  border: $business-class-card-border;
  border-radius: $business-class-card-border-radius;
  cursor: $business-class-card-cursor;
  user-select: $business-class-card-user-select;
  background: $business-class-card-background;
}
.cob-card:focus,
.cob-card:hover {
  background: $business-class-card-hover-background;
  border: $business-class-card-hover-border;
  .cob-title {
    color: $business-class-card-hover-title-color;
    font-weight: $business-class-card-hover-title-font-weight;
    text-decoration-line: $business-class-card-hover-title-text-decoration-line;
  }
}
.cob-title {
  color: $business-class-card-title-color;
  font-weight: $business-class-card-title-font-weight;
  font-size: $business-class-card-title-font-size;
  line-height: $business-class-card-title-line-height;
  font-family: $business-class-card-title-font-family;
}
.cob-title-secondary {
  margin-top: $business-class-card-title-secondary-margin-top;
  color: $business-class-card-title-secondary-color;
  font-weight: $business-class-card-title-secondary-font-weight;
  font-size: $business-class-card-title-secondary-font-size;
  line-height: $business-class-card-title-secondary-line-height;
  font-family: $business-class-card-title-secondary-font-family;
}

.cob-code {
  margin-top: $business-class-card-code-margin-top;
  color: $business-class-card-code-color;
  font-weight: $business-class-card-code-font-weight;
  font-size: $business-class-card-code-font-size;
  line-height: $business-class-card-code-line-height;
  font-family: $business-class-card-code-font-family;
}
